import React, { useEffect } from 'react'
import { useContext } from 'react'
import GlobalStateContext from '../../../../context'
import MediaPannelBanner from './mediaPannelBanners/MediaPannelBanner'
import './MediaPanelOverlay.css'




export function MediaPanelOverlayBanner({ banner }) {
  return (
    <div className={`banner ${banner.scroll ? 'scrollable' : ''}`}>
      {!!banner.title && <div className='banner-title'>{banner.title}</div>}
      {banner.scroll ?
        <div className={`banner-description scrolling-limit`} >
          <div className='scrolling'>{banner.text}</div>
        </div>
        :
        <div className={`banner-description`} >{banner.text}</div>}
    </div>
  )
}


export default function MediaPanelOverlay({ mediaPanel }) {


  const [gState, dispatch] = useContext(GlobalStateContext)
  let banners = [];
  if (!!mediaPanel) {
    banners = mediaPanel?.banners || []
  }

  useEffect(() => {
    console.log("MediaPanelOverlay - mediaPanel:", mediaPanel)
    console.log("MediaPanelOverlay - logo visibility:", mediaPanel?.logo?.visible)
    console.log("MediaPanelOverlay - logo url:", mediaPanel?.logo?.url)
  }, [mediaPanel])

  return (
    <div className='mediaPanelOverlay' >
      <div className="branding">
        <div className={`branding-logo ${mediaPanel?.logo?.visible !== false && mediaPanel?.logo?.url ? 'visible' : 'hidden'}`}>
          {mediaPanel?.logo?.url && (
            <img
              src={mediaPanel?.logo?.url}
              alt={mediaPanel?.logo?.name}
              className={`logo-image ${mediaPanel?.logo?.size || 'small'} ${mediaPanel?.logo?.position || 'top-right'}`}
            />
          )}
        </div>
      </div>

      <div className='banners'>
        {

          banners && banners.map((item, index) => {
            return <MediaPannelBanner key={index} banner={item} theme={mediaPanel?.theme} />
          })
        }

      </div>
    </div>
  )
}
